// ExamInsurancePage.tsx

import { useTranslation } from "react-i18next";
import { ShieldMoon, Verified, HealthAndSafety } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material";
import quizApi from "@/services/quizService";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import type { BrandResolver } from "@/types/Portal.types";
import BaseExamPortalPage from "./BaseExamPortalPage";

const getInsuranceBrand =
  (isDark: boolean): BrandResolver =>
  (item) => {
    const name = item.quizName.toLowerCase();
    if (name.includes("paper 1") || name.includes("paper 3")) {
      const accent = isDark ? "#38bdf8" : "#0284c7";
      return {
        icon: Verified,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    if (name.includes("paper 5") || name.includes("investment")) {
      const accent = isDark ? "#60a5fa" : "#0369a1";
      return {
        icon: HealthAndSafety,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    const accent = isDark ? "#2dd4bf" : "#0f766e";
    return {
      icon: ShieldMoon,
      accentColor: accent,
      gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
    };
  };

export default function ExamInsurancePage() {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <BaseExamPortalPage
      title={t("pages.examInsurance.title")}
      subtitle={t("pages.examInsurance.subtitle")}
      actionText={t("pages.examInsurance.actionText")}
      themeConfig={{
        activeTabBg: theme.palette.primary.main,
        activeTabTextColor: theme.palette.primary.contrastText,
        borderColor: theme.palette.divider,
      }}
      fetchData={async () => {
        const res = await quizApi.getQuizzes({ search: "insurance", limit: 99 });
        return res.data;
      }}
      brandResolver={getInsuranceBrand(isDark)}
      onItemSelect={(item) => navigate(`mock/quiz/${item.quizName}`)}
      isDisabled={true}
    />
  );
}
